import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, CardFooter, CardTitle, CardText } from 'reactstrap';
import { throttle } from 'lodash';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSession } from '@cordata/buffet';

import { PageLayout, Navbar } from '~/components';

import {
  authorizedPyPublicInstance as Public,
  authorizedInstanceNoBase as full,
  useSubscriptions,
} from '~/utils';

import CategoryList from './CategoryList';
import CategoryListHeader from './CategoryListHeader';
import MessageList from './MessageList';
import Prompt from './Prompt';

const FullHeight = styled(Row)`
  height: ${({ height }) => height - 88}px;
`;

const ChatWindow = ({ currentSubscription }) => {
  const [height, setHeight] = useState(window.innerHeight);
  const [currentTopic, setCurrentTopic] = useState({});
  const [currentSubject, setCurrentSubject] = useState({});
  const { current } = useSession();

  const subscription = useSubscriptions(currentSubscription);

  const parseInnerHeight = throttle(
    () =>
      setHeight(window.innerHeight)
    , 200,
  );

  useEffect(() => {
    window.addEventListener('resize', parseInnerHeight);

    return () =>
      window.removeEventListener('resize', parseInnerHeight);
  }, []);

  useEffect(() => {
    if (currentSubscription && subscription) {
      setCurrentTopic(subscription.attributes.realTimeTopicUid);

      full
        .get(subscription.relationships.realTimeTopic.related)
        .then(r => r.data.data)
        .then(r => Public
          .get(`patient/${r.attributes.subjectUid}`))
        .then(r => r.data.data)
        .then(r => full
          .get(r.relationships.person.related))
        .then(r => r.data.data)
        .then(setCurrentSubject);
    }
  }, [currentSubscription, subscription]);

  return (
    <PageLayout Header={Navbar}>
      <FullHeight height={height}>
        <Col sm={3} className="h-100">
          <Card
            color="dark"
            outline
          >
            <CategoryListHeader />
            <CategoryList currentTopic={currentTopic} />
          </Card>
        </Col>

        <Col sm className="h-100">
          <Card
            color="dark"
            outline
            className="h-100"
          >
            {currentSubscription && currentSubject.attributes ? (
              <CardHeader>
                Talking about:{' '}
                <strong>
                  {currentSubject.attributes.lastName}, {currentSubject.attributes.firstName}
                </strong>
              </CardHeader>
            ) : (
              <CardBody>
                <CardTitle>Hi, {current && current.attributes.userName}!</CardTitle>

                <CardText>Click on a conversation or feel free to start one.</CardText>
              </CardBody>
          )}

            <CardBody className="overflow-auto pt-2" id="message-list">
              <MessageList subscription={subscription} currentTopic={currentTopic} />
            </CardBody>

            <CardFooter>
              <Prompt subscription={subscription} />
            </CardFooter>
          </Card>
        </Col>
      </FullHeight>
    </PageLayout>
  );
};

ChatWindow.propTypes = {
  currentSubscription: PropTypes.string,
};

ChatWindow.defaultProps = {
  currentSubscription: undefined,
};

export default ChatWindow;
